import React, { useEffect, useState } from "react";
import Filters from "views/shared/Filters";
import { Container, Card, CardBody } from "reactstrap";
import ChartContainer from "./ChartsContainer.jsx";
import { useParams } from "react-router-dom";
import { Grid2 } from "@mui/material";
import DataCard from "components/DataCard.jsx";
import axios from "axios";
import { baseUrl } from "constants/url";
import authHeader from "services/auth-header";

import PacksProducedImage from "../../../assets/img/icons/packs_produced_icon_w.png";
import idleTimeImage from "../../../assets/img/icons/idleTime.png";
import runtimeimage from "../../../assets/img/icons/runtime.png";
import WeightPerMinutePerOperatorIcon from "../../../assets/img/icons/weight-per-minute-per-operator-icon.png";

function ProductionData() {
  const params = useParams();
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);

  // User's timezone
  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  // Define start and end times
  const startTime = "06:00:00"; // 6 AM
  const endTime = "18:00:00"; // 6 PM

  // Convert dates to YYYY-MM-DD format
  const startDateString = yesterday.toISOString().split("T")[0]; // "YYYY-MM-DD"
  const endDateString = today.toISOString().split("T")[0]; // "YYYY-MM-DD"

  // Combine with the fixed times and convert to ISO format
  const startDateISO = new Date(
    `${startDateString}T${startTime}Z`
  ).toISOString();
  const endDateISO = new Date(`${endDateString}T${endTime}Z`).toISOString();

  // Set initial state
  const [filtersData, setFiltersData] = useState({
    start_date: startDateISO,
    end_date: endDateISO,
    timezone: userTimezone,
    start_time: "06:00",
    end_time: "18:00",
    recipe: "All",
    product: "All",
    tool: "All",
  });
  const [resData, setResData] = useState({
    isLoading: true,
    metrics: {
      "Packs Produced": 0,
      "Idle Time Total": 0,
      "Run Time Total": 0,
      OEEE: 0,
    },
  });

  const handleApplyFilters = (filterData) => {
    setFiltersData({ ...filterData });
  };

  const secondsToHoursMinutes = (seconds) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    return `${hours}h ${minutes}m`;
  };

  useEffect(() => {
    if (filtersData.start_date && filtersData.end_date) {
      setResData({
        isLoading: true,
        metrics: {
          "Packs Produced": 0,
          "Idle Time Total": 0,
          "Run Time Total": 0,
          OEEE: 0,
        },
      });
      axios
        .get(`${baseUrl}/api/admin/day-summary`, {
          params: {
            clientId: params.clientId,
            machine: params.machineId,
            ...filtersData,
          },
          headers: authHeader(),
        })
        .then((res) => {
          setResData({
            isLoading: false,
            metrics: res.data.metrics,
          });
        })
        .catch((err) => {
          setResData({
            isLoading: false,
            metrics: {
              "Packs Produced": 0,
              "Idle Time Total": 0,
              "Run Time Total": 0,
              OEEE: 0,
            },
          });
        });
    }
  }, [filtersData, params.clientId, params.machineId]);

  return (
    <Container fluid>
      <Card className="m-3 mb-4">
        <CardBody className="rounded px-5 py-4">
          <Filters
            filtersData={filtersData}
            handleApplyFilters={handleApplyFilters}
            clientId={params.clientId}
            machineId={params.machineId}
          />
        </CardBody>
      </Card>
      <Grid2
        container
        // direction="column"
        // justifyContent="space-between"
        alignItems="center"
        style={{ minHeight: "100%" }}
        spacing={1}
        className="m-3 mb-4"
      >
        <Grid2 item xs={3} md={6} lg={3} sx={{ flexGrow: 1 }}>
          <DataCard
            isLoading={resData.isLoading}
            message={"Packs Produced"}
            cardImage={PacksProducedImage}
            cardData={{
              title: "Packs Produced",
              // durationDays: cardsData.durationDays,
              count: resData.metrics["Packs Produced"],
              // sinceValue: cardsData.totalGa.sinceValue,
            }}
            toolTipData={{
              id: "tga-card-tooltip",
              message: "Total packs produced in the selected time",
              message: "Total packs produced in the selected time",
            }}
            revert_order
          />
        </Grid2>

        <Grid2 item xs={3} md={6} lg={3} sx={{ flexGrow: 1 }}>
          <DataCard
            isLoading={resData.isLoading}
            message={"Idle Time Total"}
            cardImage={idleTimeImage}
            cardData={{
              title: "Idle Time Total",
              // durationDays: cardsData.durationDays,
              count: secondsToHoursMinutes(resData.metrics["Idle Time Total"]),
              // sinceValue: cardsData.totalGa.sinceValue,
            }}
            toolTipData={{
              id: "tga-card-tooltip2",
              message:
                "The time for which machines were running but not packing",
            }}
            revert_order
          />
        </Grid2>
        <Grid2 item xs={3} md={6} lg={3} sx={{ flexGrow: 1 }}>
          <DataCard
            isLoading={resData.isLoading}
            message={"Run Time Total"}
            cardImage={runtimeimage}
            cardData={{
              title: "Run Time Total",
              // durationDays: cardsData.durationDays,
              count: secondsToHoursMinutes(resData.metrics["Run Time Total"]),
              // sinceValue: cardsData.totalGa.sinceValue,
            }}
            toolTipData={{
              id: "tga-card-tooltip3",
              message: "The time for which machines were packing",
              message: "The time for which machines were packing",
            }}
            revert_order
          />
        </Grid2>
        <Grid2 item xs={3} md={6} lg={3} sx={{ flexGrow: 1 }}>
          <DataCard
            isLoading={resData.isLoading}
            message={"OEEE"}
            cardImage={WeightPerMinutePerOperatorIcon}
            cardData={{
              title: "OEEE",
              // durationDays: cardsData.durationDays,
              count: resData.metrics["OEEE"],
              // sinceValue: cardsData.totalGa.sinceValue,
            }}
            toolTipData={{
              id: "tga-card-tooltip4",
              message:
                "The fraction of time machine was idle comparison to running",
            }}
            revert_order
          />
        </Grid2>
      </Grid2>
      <ChartContainer
        filtersData={filtersData}
        setFiltersData={setFiltersData}
        clientId={params.clientId}
        machineId={params.machineId}
      />
    </Container>
  );
}

export default ProductionData;
